import { Base } from '@gate31/core/src/libs/BaseComponent';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { ProductFormAction } from '@gate31/feature/ProductFormAction/ProductFormAction'

export class ProductFormActionDesk extends ProductFormAction {
    static cn = new Base.BuildCn('ProductFormDesk');

    constructor({ node, product }: { node: HTMLElement; product: InsalesProduct }) {
        super({ node, product, cn: ProductFormActionDesk.cn });
    }
}

export class ProductFormActionSnippetDesk extends ProductFormAction {
    static cn = new Base.BuildCn('CardModalFormDesk');

    constructor({ node, product }: { node: HTMLElement; product: InsalesProduct }) {
        super({ node, product, cn: ProductFormActionSnippetDesk.cn });
    }
}